<!--设备属性编辑界面-->
<template>
	<div class="archiversType">
		<!--左边-->
		<elEntityTypeTree @getShow="isShow=$event" :dataList="getEntityTypeList" @checkItem="checkItem">
		</elEntityTypeTree>
		<div class="archiversType-rigth" :style="atrStyle">
			<div class="addTree">
				<div style="width: 90%;margin-top: 10px;margin-left: 2%;">
					<el-button type="primary" size='mini' @click="addSuperiorShow=true,addType='同级'">添加同级</el-button>
					<el-button type="primary" size='mini' @click="addSuperiorShow=true,addType='子级'">添加子级</el-button>
				</div>
				<el-table :data="treeTableList" stripe style="width: 100%;margin-top: 10px;" border :header-cell-style="{background:'#eef1f6',color:'#606266','text-align':'center'}">
					<el-table-column type="index" width="50">
					</el-table-column>
					<el-table-column prop="mainTypeCode" label="上级类型编码">
					</el-table-column>
					<el-table-column prop="typeCode" label="类型编码">
					</el-table-column>
					<el-table-column prop="typeName" label="类型名称">
					</el-table-column>
					<el-table-column prop="editable" label="是否可编辑" :formatter="formatEditable">
					</el-table-column>
					<el-table-column label="操作" width='180' prop='editable'>
						<template slot-scope="scope">
							<el-button size="mini" @click="editSuperior(scope.row)" :disabled="scope.row.editable==1?false:true">编辑</el-button>
							<el-button size="mini" type="danger" @click="deleteArchives('上级',scope.row)" :disabled="scope.row.editable==1?false:true">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="addAttributes">
				<div style="width: 90%;margin-top: 5%;margin-left: 2%;display: flex;align-items: center;">
					<!-- :disabled="this.treeTableList[0].editable==1?false:true"-->
					<el-button type="primary" size='mini' @click='addPropertyShow=true'>添加属性</el-button>
					<div style="width: 15%;margin-left: 20px;">
						<el-input v-model="search" size="medium" placeholder="输入关键字搜索" style="width:200px" />
					</div>
				</div>
				<el-table :data="attributesList.filter(data => !search || data.propertyName.toLowerCase().includes(search.toLowerCase()))" height="650" stripe style="width: 100%;margin-top: 10px;" border :header-cell-style="{background:'#eef1f6',color:'#606266','text-align':'center'}">
					<el-table-column type="index" width="50">
					</el-table-column>
					<el-table-column prop="propertyName" label="属性名称">
					</el-table-column>
					<el-table-column prop="typePropertyCode" label="属性编码">
					</el-table-column>
					<el-table-column prop="valueType" label="值类型" :formatter="formatValueType">
					</el-table-column>
					<el-table-column prop="defaultValue" label="默认值">
					</el-table-column>
					<el-table-column prop="editable" label="是否可编辑" :formatter="formatEditable">
					</el-table-column>
					<el-table-column prop="isOnly" label="值是否唯一" :formatter="formatterIsOnly">
					</el-table-column>
					<el-table-column prop="nullable" label="是否可以为空" :formatter="formatterNullable">
					</el-table-column>
					<el-table-column label="操作" width='180' prop="editable">
						<template slot-scope="scope">
							<el-button size="mini" @click="editClick(scope.row)" :disabled="scope.row.editable==1?false:true">编辑</el-button>
							<el-button size="mini" type="danger" @click="deleteArchives('属性',scope.row)" :disabled="scope.row.editable==1?false:true">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<el-dialog title="编辑类型" :visible.sync="editSuperiorShow">
			<el-form :model="editSuperiorForm">
				<el-form-item label="类型名称" label-width="120px">
					<el-input v-model="editSuperiorForm.typeName" auto-complete="off" style="width:70%;"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editSuperiorShow = false">取 消</el-button>
				<el-button type="primary" @click="confirmSuperiorForm()">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="编辑属性" :visible.sync="propertyShow">
			<el-form :model="editPropertyForm" :rules="editRules" ref="editPropertyForm">
				<el-form-item label="属性名称" label-width="120px" prop="propertyName">
					<el-input v-model="editPropertyForm.propertyName" auto-complete="off" style="width:70%;"></el-input>
				</el-form-item>
				<el-form-item label="值类型" label-width="120px" prop="valueType">
					<el-select v-model="editPropertyForm.valueType" placeholder="请选择值类型" style="width: 70%;">
						<el-option :label="item.text" :value="item.value" v-for='item in getValueEnum'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="默认值" label-width="120px" prop="defaultValue">
					<el-input v-model="editPropertyForm.defaultValue" auto-complete="off" style="width:70%;"></el-input>
				</el-form-item>
				<el-form-item label="是否可编辑" label-width="120px" prop="editable">
					<el-radio v-model="editPropertyForm.editable" label="1">是</el-radio>
					<el-radio v-model="editPropertyForm.editable" label="0">否</el-radio>
				</el-form-item>
				<el-form-item label="值是否唯一" label-width="120px" prop="isOnly">
					<el-radio v-model="editPropertyForm.isOnly" label="1">是</el-radio>
					<el-radio v-model="editPropertyForm.isOnly" label="0">否</el-radio>
				</el-form-item>
				<el-form-item label="是否允许为空" label-width="120px" prop="nullable">
					<el-radio v-model="editPropertyForm.nullable" label="1">是</el-radio>
					<el-radio v-model="editPropertyForm.nullable" label="0">否</el-radio>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="propertyShow = false">取 消</el-button>
				<el-button type="primary" @click="editPropertyConfirm()">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="添加类型" :visible.sync="addSuperiorShow">
			<el-form :model="addSuperiorForm">
				<el-form-item label="类型名称" label-width="120px">
					<el-input v-model="addSuperiorForm.typeName" auto-complete="off" style="width:70%;"></el-input>
				</el-form-item>
				<el-form-item label="类型编码" label-width="120px">
					<el-input v-model="addSuperiorForm.typeCode" auto-complete="off" style="width:70%;"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addSuperiorShow = false">取 消</el-button>
				<el-button type="primary" @click="addConfirm">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="添加属性" :visible.sync="addPropertyShow">
			<el-form :model="addPropertyForm" :rules="rules" ref="addPropertyForm">
				<el-form-item label="属性名称" label-width="120px" prop="propertyName">
					<el-input v-model="addPropertyForm.propertyName" auto-complete="off" style="width:70%;"></el-input>
				</el-form-item>
				<el-form-item label="属性编码" label-width="120px" prop="typeCode">
					<el-input v-model="addPropertyForm.typeCode" auto-complete="off" style="width:70%;"></el-input>
				</el-form-item>
				<el-form-item label="值类型" label-width="120px" prop="valueType">
					<el-select v-model="addPropertyForm.valueType" placeholder="请选择值类型" style="width: 70%;">
						<el-option :label="item.text" :value="item.value" v-for='item in getValueEnum'></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="默认值" label-width="120px" prop="defaultValue">
					<el-input v-model="addPropertyForm.defaultValue" auto-complete="off" style="width:70%;"></el-input>
				</el-form-item>
				<el-form-item label="是否可编辑" label-width="120px" prop="editable">
					<el-radio v-model="addPropertyForm.editable" label="1">是</el-radio>
					<el-radio v-model="addPropertyForm.editable" label="0">否</el-radio>
				</el-form-item>
				<el-form-item label="值是否唯一" label-width="120px" prop="isOnly">
					<el-radio v-model="addPropertyForm.isOnly" label="1">是</el-radio>
					<el-radio v-model="addPropertyForm.isOnly" label="0">否</el-radio>
				</el-form-item>
				<el-form-item label="是否允许为空" label-width="120px" prop="nullable">
					<el-radio v-model="addPropertyForm.nullable" label="1">是</el-radio>
					<el-radio v-model="addPropertyForm.nullable" label="0">否</el-radio>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="addPropertyShow = false">取 消</el-button>
				<el-button type="primary" @click="addPropertyConfirm()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script type="text/javascript">
	import elEntityTypeTree from '@/components/module/tree/elEntityTypeTree.vue'
	export default {
		//inject: ['reload'],
		components: {
			elEntityTypeTree,
		},
		props: [],
		data() {
			return {
				treeList: [],
				treeTableList: [],
				attributesList: [],
				editSuperiorShow: false, //编辑上级类型
				editSuperiorForm: {
					date: '',
					typeCode: '',
					typeName: '',
					editable: ''
				},
				propertyShow: false,
				editPropertyForm: {
					propertyName: '',
					valueType: '',
					defaultValue: '',
					editable: '',
					nullable: ''
				},
				addSuperiorShow: false,
				addSuperiorForm: {
					typeName: '',
					typeCode: ''
				},
				addType: '', //添加的类型
				addPropertyShow: false,
				addPropertyForm: {
					propertyName: '',
					typeCode: '',
					valueType: 0,
					defaultValue: '',
					editable: '1',
					isOnly: '1',
					nullable: '1',
				},
				search: '',
				getEntityTypeList: [], //树数据
				rules: {
					propertyName: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					typeCode: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					defaultValue: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
				},
				editRules: {
					propertyName: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					typeCode: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					valueType: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					defaultValue: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					editable: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					isOnly: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					nullable: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
				},
				isShow:true,
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			//初始化数据
			this.$api.entityApi.getEntityTypeList(respon => {
				if(!isempty(respon)) {
					this.getEntityTypeList = deviceList(respon)
					this.treeTableList = [this.getEntityTypeList[0]]
					this.initData(this.getEntityTypeList[0].typeCode)
				}
			})
			this.isShow=this.$refs.eltree.isShow
		},
		destroyed() {},
		computed: {
			getValueEnum() {
				return this.$store.archivesStore.state.valueEnum
			},
			atrStyle() {
				let width = '100%'
				if(this.isShow) {
					width = 'calc(100% - 2.26rem)'
				}
				return {
					"width": width
				}
			}
		},
		watch: {},
		methods: {
			//编辑上级类型-赋值
			editSuperior(val) {
				this.editSuperiorShow = true
				this.editSuperiorForm = copy(val)
			},
			initData(typeCode) {
				this.$api.entityApi.getTypePropertyList(typeCode, respon => {
					this.attributesList = respon
				})
			},
			getEntityList() {
				//获取树数据
				this.$api.entityApi.getEntityTypeList(respon => {
					if(!isempty(respon)) {
						this.getEntityTypeList = deviceList(respon)
					}
				})
			},
			checkItem(data) {
				this.treeTableList = [data]
				this.initData(data.typeCode)
			},
			confirmSuperiorForm() {
				//确认修改上级编码
				this.$api.entityApi.updateEntityType(this.treeTableList[0].typeCode, this.editSuperiorForm.typeName, this.treeTableList[0].mainTypeCode, '', respon => {
					if(!isempty(respon)) {
						this.$message({
							message: '修改成功',
							type: 'success'
						})
						//this.reload()
						this.getEntityList()
					}
				})
				this.editSuperiorShow = false
			},
			addConfirm() {
				//确认添加上级或者同级
				if(this.addType == '同级') {
					//添加同级
					this.$api.entityApi.createEntityType(this.addSuperiorForm.typeCode, this.addSuperiorForm.typeName, this.treeTableList[0].mainTypeCode, '', respon => {
						if(!isempty(respon)) {
							this.getEntityList()
							this.$message({
								message: '添加成功',
								type: 'success'
							})
						}
					})
				} else {
					//添加子级
					this.$api.entityApi.createEntityType(this.addSuperiorForm.typeCode, this.addSuperiorForm.typeName, this.treeTableList[0].id, '', respon => {
						if(!isempty(respon)) {
							this.getEntityList()
							this.$message({
								message: '添加成功',
								type: 'success'
							})
						}
					})
				}
				this.addSuperiorShow = false
			},
			editPropertyConfirm() {
				//确认修改属性
				let data = this.editPropertyForm
				this.$refs.editPropertyForm.validate((valid) => {
					if(valid) {
						this.$api.entityApi.updateTypeProperty(
							data.entityTypeCode,
							data.typePropertyCode,
							data.propertyName,
							data.valueType,
							data.readOnly,
							data.editable,
							data.isOnly,
							data.nullable,
							data.isVisiable,
							data.align,
							data.enumCode,
							data.sort,
							data.tag,
							data.formula,
							data.orderFlag,
							data.defaultValue,
							respon => {
								if(!isempty(respon)) {
									this.initData(this.treeTableList[0].typeCode)
									this.propertyShow = false
									this.$message({
										message: '修改成功',
										type: 'success'
									})
								}
							}, err => {
								this.$message({
									type: 'error',
									message: err
								});
							})
					} else {
						return false;
					}
				})
			},
			editClick(item) {
				//打开编辑弹窗
				this.editPropertyForm = copy(item)
				this.editPropertyForm.editable = copy(item.editable.toString())
				this.editPropertyForm.nullable = copy(item.nullable.toString())
				this.editPropertyForm.isOnly = copy(item.isOnly.toString())
				this.propertyShow = true
			},
			addPropertyConfirm() {
				this.$refs.addPropertyForm.validate((valid) => {
					if(valid) {
						//确认添加属性
						this.$api.entityApi.createTypeProperty(
							this.treeTableList[0].typeCode,
							this.addPropertyForm.typeCode,
							this.addPropertyForm.propertyName,
							this.addPropertyForm.valueType,
							'',
							this.addPropertyForm.editable,
							this.addPropertyForm.isOnly,
							this.addPropertyForm.nullable,
							'',
							'',
							'',
							'',
							'',
							'',
							'',
							this.addPropertyForm.defaultValue,
							respon => {
								if(!isempty(respon)) {
									this.addPropertyShow = false
									this.$message({
										type: 'success',
										message: '添加成功!'
									});
									this.initData(this.treeTableList[0].typeCode)
									//添加完成之后情况输入框的值
									this.addPropertyForm.propertyName = ''
									this.addPropertyForm.typeCode = ''
									this.addPropertyForm.defaultValue = ''
								}
							}, err => {
								this.$message({
									type: 'error',
									message: err
								});
							})
					} else {
						return false;
					}
				});
			},
			deleteArchives(type, item) {
				//删除台账
				this.$confirm('此操作将永久删除该类型, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if(type == '上级') {
						this.$api.entityApi.deleteEntityType(item.typeCode, respon => {
							if(!isempty(respon)) {
								this.getEntityList()
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
							}
						}, err => {
							this.$message({
								type: 'error',
								message: err
							});
						})
					} else {
						//删除属性
						this.$api.entityApi.deleteTypeProperty(item.entityTypeCode, item.typePropertyCode, respon => {
							if(!isempty(respon)) {
								this.$message({
									type: 'success',
									message: '删除成功!'
								});
								this.initData(this.treeTableList[0].typeCode)
							}
						})
					}
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			isEdit(value) {
				return value == 0 ? false : true
			},
			//格式化内容
			formatEditable(row, column, cellValue) {
				if(isempty(row)) {
					return
				}
				return row.editable === 1 ? '是' : '否'
			},
			formatValueType(row, column, cellValue) {
				if(isempty(row)) {
					return
				}
				if(!isempty(this.$store.archivesStore.state.valueEnum[row.valueType])){
					return this.$store.archivesStore.state.valueEnum[row.valueType].text
				}
			},
			formatterIsOnly(row, column, cellValue) {
				if(isempty(row)) {
					return
				}
				return row.isOnly === 1 ? '是' : '否'
			},
			formatterNullable(row, column, cellValue) {
				if(isempty(row)) {
					return
				}
				return row.nullable === 1 ? '是' : '否'
			}
		}
	}
</script>

<style scoped>
	.archiversType {
		width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: space-between;
		background-color: white;
	}
	
	.archiversType-rigth {
		height: 100%;
	}
	
	.addTree {
		width: 100%;
		height: 15%;
	}
	
	.addAttributes {
		width: 100%;
		height: 70%;
	}
</style>
<style>
	.archiversType .el-dialog {
		width: 35%;
	}
</style>